import { Badge } from "@chakra-ui/react";

// A guest checkout order has no linked user account, so lxa__orders.user_id
// comes back empty / null / 0 / -1. A real (logged-in) customer order carries
// a positive user_id. This lets admins and PMs tell at a glance whether an
// order came from a guest checkout or a registered account.
export const isGuestOrder = (userId?: string | number | null): boolean => {
  if (userId === undefined || userId === null || userId === "") return true;
  const n = Number(userId);
  if (Number.isNaN(n)) return true;
  return n <= 0;
};

interface CustomerTypeBadgeProps {
  userId?: string | number | null;
  size?: "sm" | "md";
}

export function CustomerTypeBadge({ userId, size = "sm" }: CustomerTypeBadgeProps) {
  const guest = isGuestOrder(userId);

  return (
    <Badge
      colorScheme={guest ? "orange" : "green"}
      variant="subtle"
      borderRadius="6px"
      px={size === "md" ? "8px" : "6px"}
      py="1px"
      fontSize={size === "md" ? "11px" : "9px"}
      lineHeight="16px"
      fontWeight="600"
      textTransform="none"
      whiteSpace="nowrap"
    >
      {guest ? "Guest" : "Account"}
    </Badge>
  );
}
